import { appItem } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500/10 via-accent-500/5 to-background-50 rounded-xl border border-background-200/70 p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 border border-primary-200/60 text-primary-700 text-xs font-semibold mb-4 whitespace-nowrap">
                <i className="ri-smartphone-line text-sm"></i>
                移动体验
              </div>
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">{appItem.title}</h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg">{appItem.desc}</p>
              <div className="flex flex-wrap gap-3 justify-center lg:justify-start mb-6">
                {appItem.features.map((f, i) => (
                  <span key={i} className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-background-50 border border-background-200/70 rounded-full text-xs text-foreground-600 whitespace-nowrap">
                    <i className="ri-check-line text-primary-500 text-sm"></i>
                    {f}
                  </span>
                ))}
              </div>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-smartphone-line"></i>
                立即体验移动版
              </a>
            </div>
            <div className="flex-shrink-0 w-[240px] h-[480px] rounded-2xl border-4 border-background-200 overflow-hidden bg-background-50 relative">
              <div className="absolute top-0 left-0 right-0 h-8 bg-background-200 flex items-center justify-center">
                <div className="w-16 h-1.5 rounded-full bg-background-300"></div>
              </div>
              <div className="pt-10 px-4 flex flex-col gap-3">
                <div className="h-3 w-3/4 bg-background-200 rounded"></div>
                <div className="h-40 bg-primary-100/50 rounded-lg flex items-center justify-center">
                  <i className="ri-play-circle-line text-3xl text-primary-400"></i>
                </div>
                <div className="h-3 w-full bg-background-200 rounded"></div>
                <div className="h-3 w-5/6 bg-background-200 rounded"></div>
                <div className="h-24 bg-accent-100/50 rounded-lg mt-2"></div>
                <div className="h-3 w-2/3 bg-background-200 rounded"></div>
                <div className="h-20 bg-primary-100/50 rounded-lg"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}